/* eslint-disable react/destructuring-assignment, react/prop-types, react/require-optimization, max-len */

import ContainerWrapper from "./ContainerWrapper";
import GridRouter from "./GridRouter";
import {Helmet} from "react-helmet";
import React from "react";

const GridContainer = props => (
  <React.Fragment>
    <Helmet>
      <meta
        content="Enjoy unlimited access to designer jewelry brands. Browse thousands of styles from over 30 designers. Start building a jewelry collection you truly love!"
        name="description"
      />
    </Helmet>
    <ContainerWrapper {...props}>
      <GridRouter />
    </ContainerWrapper>
  </React.Fragment>
);

export default GridContainer;
